  <!-- Site footer -->
    <footer class="site-footer">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <h6>About</h6>
            <p class="text-justify">runcodeanytime.io <i>CODE WANTS TO BE SIMPLE </i> is an initiative  to help the upcoming programmers with the code. Scanfcode focuses on providing the most efficient code or snippets as the code wants to be simple. We will help programmers build up concepts in different programming languages that include C, C++, Java, HTML, CSS, Bootstrap, JavaScript, PHP, Android, SQL and Algorithm.</p>
          </div>

          <div class="col-xs-6 col-md-3">
            <h6>Categories</h6>
            <ul class="footer-links">
              <li><a routerLink="/">XmlToJson Converter</a></li>
              <li><a routerLink="/typescript-to-java">TypeScript to JAVA (POJO's)</a></li>
              <li><a routerLink="/code-runner">Online Compiler</a></li>
              <li><a routerLink="/">TypeScript (Angular)</a></li>
              <li><a routerLink="/">Java</a></li>
              <li><a routerLink="/">Android</a></li>
              <li><a routerLink="/">Templates</a></li>
            </ul>
          </div>

          <div class="col-xs-6 col-md-3">
            <h6>Quick Links</h6>
            <ul class="footer-links">
              <li><a routerLink="/">About Us</a></li>
              <li><a routerLink="/">Contact Us</a></li>
              <li><a routerLink="/">Contribute</a></li>
              <li><a routerLink="/">Privacy Policy</a></li>
              <li><a routerLink="/">Sitemap</a></li>
            </ul>
          </div>
        </div>
        <hr>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-sm-6 col-xs-12">
            <p class="copyright-text">Copyright &copy; 2021 All Rights Reserved by
         <a href="#">Propenster</a>.
            </p>
          </div>

          <div class="col-md-4 col-sm-6 col-xs-12">
            <ul class="social-icons">
              <li><a class="facebook" routerLink="#"><i class="fa fa-facebook"></i></a></li>
              <li><a class="twitter" routerLink="#"><i class="fa fa-twitter"></i></a></li>
              <li><a class="dribbble" routerLink="#"><i class="fa fa-dribbble"></i></a></li>
              <li><a class="linkedin" routerLink="#"><i class="fa fa-linkedin"></i></a></li>
            </ul>
          </div>
        </div>
      </div>
</footer>
